export default __webpack_public_path__ + "static/7 things-a-platinum-credit-card-can-do-for-you-happy-millenials-2d58f54e253e27bc901a76259029498d.jpg";